import { createServerFn } from '@tanstack/react-start'
import { bookingNotificationSchema, photoNotificationSchema } from './notifications-schemas'

export const notifyBookingRequest = createServerFn({ method: 'POST' })
  .inputValidator((data: unknown) => bookingNotificationSchema.parse(data))
  .handler(async ({ data }) => {
    const { sendBookingNotifications } = await import('./notifications.server')
    await sendBookingNotifications(data)
    return { ok: true }
  })

export const notifyPhotoSubmission = createServerFn({ method: 'POST' })
  .inputValidator((data: unknown) => photoNotificationSchema.parse(data))
  .handler(async ({ data }) => {
    const { sendPhotoNotifications } = await import('./notifications.server')
    await sendPhotoNotifications(data)
    return { ok: true }
  })
